import { has as _has } from "lodash-es";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory, withRouter } from "react-router-dom";
import { Formik, Form } from "formik";
import PropTypes from "prop-types";
import * as yup from "yup";

import { loginUser } from "../actions/user";
import { fetchUpdates } from "../actions/sync";
import { getPostAuthRedirectPath } from "../utils";
import Loading from "../components/Loading";
import LabeledFormField from "../components/LabeledFormField";
import Button from "../components/Button";

const mapDispatchToProps = (dispatch) => ({
  loginUser: (email, password) => dispatch(loginUser(email, password)),
  fetchUpdates: () => dispatch(fetchUpdates()),
});

function Login(props) {
  const history = useHistory();
  const [showLoader, setShowLoader] = useState(false);
  const validationSchema = yup.object().shape({
    email: yup.string().required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  function onSubmit({ email, password }, actions) {
    setShowLoader(true);
    props.loginUser(email, password).then((action) => {
      if (action.error) {
        setShowLoader(false);
        const { response } = action.error.response.data;
        if (_has(response, "errors")) {
          actions.setErrors({
            password: response.errors.password,
            email: response.errors.email,
          });
          actions.setSubmitting(false);
        }
      } else {
        if (props.closeModal) {
          props.closeModal();
        }
        props.fetchUpdates().then((action) => {
          history.push(getPostAuthRedirectPath());
        });
      }
    });
  }

  function redirectToLoginPage() {
    history.push("/logout");
  }

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 mt-3">
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl mb-3">Sign in to your account</h1>
        <Formik
          initialValues={{
            email: props.source === "fromLoginModal" ? props.userEmail : "",
            password: "",
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <LabeledFormField
                label="Email"
                type="text"
                name="email"
                tabIndex="1"
                disabled={props.source === "fromLoginModal" ? true : false}
              />
              <LabeledFormField
                label="Password"
                type="password"
                name="password"
                tabIndex="1"
              />
              <div>
                <Button
                  className="mt-4"
                  type="submit"
                  disabled={isSubmitting || showLoader}
                >
                  Sign in
                  {showLoader && (
                    <div className="text-center ml-1 relative top-0.5">
                      <Loading />
                    </div>
                  )}
                </Button>
                &nbsp; or &nbsp;
                {props.source === "fromLoginModal" ? (
                  <Button onClick={redirectToLoginPage} type="button">
                    Sign in as another user
                  </Button>
                ) : (
                  <Link to="/sign-up">
                    <Button type="button" intent="nooutline">
                      Create an Account
                    </Button>
                  </Link>
                )}
              </div>
              {props.source !== "fromLoginModal" && (
                <div className="mt-4">
                  <Link
                    className="text-blue-700 hover:text-blue-900"
                    to="/reset-password"
                  >
                    Forgot your password?
                  </Link>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

Login.propTypes = {
  source: PropTypes.string,
  userEmail: PropTypes.string,
  loginUser: PropTypes.func,
  closeModal: PropTypes.func,
  fetchUpdates: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(connect(null, mapDispatchToProps)(Login));
